import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'Components/Button';
import styles from './BookAlternateLanguageBox.scss';

const BookAlternateLanguageBox = ({ alternateLanguageVersions, params }) => {
  const { pageID } = params;
  return alternateLanguageVersions.map(({ slug, title, languageLabel }) => (
    <div key={slug} className="BookAlternateLanguageBox">
      <h3>Looking for the {languageLabel} version?</h3>
      <p>This book is also available in {languageLabel}</p>
      <Link to={`/books/${slug}/page/${pageID}`}>
        <Button text="Read" mediaType="book" />
      </Link>
    </div>
  ));
};

export default BookAlternateLanguageBox;
